import { datiFatturazione } from './datiFatturazione';
import { ServizioPerImpianto } from './servizio';
export class Implant {
  Id: number;
  Nome: string;
  Cognome: string;
  NomeImpianto: string;
  EmailReferenteInterno: string;
  //EmailImpianto: string;
  //Password: string;
  KeyImpianto: string;
  ConversioniAbilitata: boolean;
  NrCarteConvertibili: number;
  KeySetPartenza: string;
  Crediti: number;
  UserId: string; 
  RicaricaAbilitata: boolean;
  NrCreditiPerCartaRicarica: number;
  ObbligoAssociazioneUtenteCarta: boolean;
  ProprietarioId: number;
  Proprietario: string;
  Fatturazione: datiFatturazione;
  Servizi: ServizioPerImpianto[];
  TipoImpianto: TipoImpianto;
  ApiSecretKey: string;
  BloccoSequenzialeServiziCash: number;
  BloccoSequenzialeTipoCarta: number;
  GestisceStandAlone: boolean;
  GestisceSecondaFasciaOrariaStandAlone: boolean;
  TipoCarteDaGestire: TipoCarteDaGestire;
  IsPrezzoServizioEditabileDaImpianto: boolean;
  IsSilicloudAbilitato: boolean;
  ChiaveCifraturaCarta: string;
  constructor() {
    //this.EmailImpianto = "";
    //this.Password = "";
    this.Fatturazione = new datiFatturazione();
    this.Servizi = [];
    this.TipoCarteDaGestire = new TipoCarteDaGestire();
  }
}

export enum TipoImpianto {
  Silicard = 0,
  Silitronic
}

export class InfoCasseBanner {
  NumeroCasse: number;
  NumeroBanner: number;
  ServiziAttivi: number[];
}

export class ImpiantoIdNomeVM {
  Id: number;
  NomeImpianto: string;
}

export class NuovoProprietarioVM {
  id: number;
  Nome: string;
  Cognome: string;
  RagioneSociale: string;
}

export class TipoCarteDaGestire {
  CartaSet: boolean;
  CartaTempo: boolean;
  CartaRicarica: boolean;   //Questo tipo di carta è presente nell'enumerato ma non viene gestita 
  CartaEuroCrediti: boolean; //Questo tipo di carta è presente nell'enumerato ma non viene gestita
  CartaSetV23: boolean;
  CartaSettaggioCosto: boolean;
  CartaSettaggioFuoriServizio: boolean;
  CartaSettaggioGare: boolean;
  CartaSettaggioModo: boolean;
  CartaSettaggioWifi: boolean;
  CartaTempoSilicloud: boolean;
  CartaImpiantoGruppoServizioSottogruppo: boolean;
  constructor() {
    this.CartaSet = false;
    this.CartaTempo = false;
    this.CartaSetV23 = false;
    this.CartaSettaggioCosto = false;
    this.CartaSettaggioFuoriServizio = false;
    this.CartaSettaggioGare = false;
    this.CartaSettaggioModo = false;
    this.CartaSettaggioWifi = false;
    this.CartaTempoSilicloud = false;
    this.CartaImpiantoGruppoServizioSottogruppo = false;
  }

}

export class EstrattoContoCreditiVM {
  CreditiInizioPeriodo: number;
  CreditiFinePeriodo: number;
  MovimentiCreditiPeriodo: EstrattoContoCreditiEntryVM[];
}

export class EstrattoContoCreditiEntryVM {
  Data: Date;
  CreditiInEntrata: number;
  CreditiInUscita: number;
  CreditiResidui: number;
  RicaricheScaricheImpianto: number;
}



// WEBPACK FOOTER //
// ./src/app/models/implant.ts